export const MOCK_COUNTRIES = [
  { Id: 'a7FD60000005MOCK01', value: 'CO', label: 'Colombia' },
  { Id: 'a7FD60000005MOCK02', value: 'VE', label: 'Venezuela' },
  { Id: 'a7FD60000005MOCK03', value: 'EC', label: 'Ecuador' },
  { Id: 'a7FD60000005MOCK04', value: 'PE', label: 'Perú' },
  { Id: 'a7FD60000005MOCK05', value: 'OTRO', label: 'Otro' },
];

export const MOCK_CIRCULATION_ZONES = [
  { label: 'Bogotá D.C. - Bogotá D.C.', circulation_zone: 'BOGOTA', value: 1, is_invalid: false, id: 'a7ID0000000MOCK001' },
  { label: 'Medellín - Antioquia', circulation_zone: 'MEDELLIN', value: 2, is_invalid: false, id: 'a7ID0000000MOCK002' },
  { label: 'Cali - Valle del Cauca', circulation_zone: 'CALI', value: 3, is_invalid: false, id: 'a7ID0000000MOCK003' },
  { label: 'Barranquilla - Atlántico', circulation_zone: 'BARRANQUILLA', value: 4, is_invalid: false, id: 'a7ID0000000MOCK004' },
  { label: 'Cartagena - Bolívar', circulation_zone: 'CARTAGENA', value: 5, is_invalid: false, id: 'a7ID0000000MOCK005' },
  { label: 'Bucaramanga - Santander', circulation_zone: 'BUCARAMANGA', value: 6, is_invalid: false, id: 'a7ID0000000MOCK006' },
  { label: 'Pereira - Risaralda', circulation_zone: 'PEREIRA', value: 7, is_invalid: false, id: 'a7ID0000000MOCK007' },
];
